import React, { FC } from 'react';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { OperationSearchItem } from '@interfaces/search';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { SingleJobOrList } from '@v2/pages/machines/modules/now/components/Job/components/SingleJobOrList';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';

interface JobDetailsJobsProps {
  jobs: ReducerEntityWithLoadingState<OperationSearchItem[]>;
  jobId: number | null;
}

const JobDetailsJobsComponent: FC<JobDetailsJobsProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  jobs,
  jobId,
}) => {
  const title = useTitle();

  useJobDetails({
    updateHeaderConfig,
    operationsSearch,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
  });

  return (
    <JobContentWrapper loading={!jobs.wasLoaded} title={title.job}>
      <SingleJobOrList displaySingleJob jobs={jobs.data} jobId={jobId} loading={!jobs.wasLoaded} />
    </JobContentWrapper>
  );
};

const JobDetailsJobs = connect(({ details: { jobs, jobId } }) => ({ jobs, jobId }), {
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
})(JobDetailsJobsComponent);

export { JobDetailsJobs };
